import React from 'react';
import { useTranslation } from 'react-i18next';
import { X, Sparkles, FileText } from 'lucide-react';

interface CreatePersonaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateWithAI: () => void;
  onCreateManually: () => void;
}

export const CreatePersonaModal: React.FC<CreatePersonaModalProps> = ({
  isOpen,
  onClose,
  onCreateWithAI,
  onCreateManually
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-25" onClick={onClose} />
        
        <div className="relative bg-white rounded-xl border border-black shadow-xl max-w-2xl w-full p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold">
              {t('personas.createPersona', 'Create Persona')}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Create with AI option */}
            <button
              onClick={onCreateWithAI}
              className="flex flex-col h-full items-center justify-center gap-4 p-6 rounded-lg border border-black hover:border-primary-600 hover:bg-primary-50 transition-colors text-center"
            >
              <div className="bg-purple-100 p-3 rounded-lg">
                <Sparkles className="h-6 w-6 text-purple-600" />
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900">
                  {t('personas.createWithAI', 'Create with AI')}
                </h3>
                <p className="mt-1 text-sm text-gray-500">
                  {t('personas.createWithAIDescription', 'Let AI help you create a realistic persona based on your brand')}
                </p>
              </div>
            </button>

            {/* Create manually option */}
            <button
              onClick={onCreateManually}
              className="flex flex-col h-full items-center justify-center gap-4 p-6 rounded-lg border border-black hover:border-primary-600 hover:bg-primary-50 transition-colors text-center"
            >
              <div className="bg-gray-100 p-3 rounded-lg">
                <FileText className="h-6 w-6 text-gray-600" />
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900">
                  {t('personas.createManually', 'Create Manually')}
                </h3>
                <p className="mt-1 text-sm text-gray-500">
                  {t('personas.createManuallyDescription', 'Write your own persona from scratch')}
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}; 